import * as React from 'react'

import { PopoverTriggerProps } from '@radix-ui/react-popover'

import { cn } from '../lib/cn'
import { useControllableState } from '../lib/hooks/useControllableState'
import { Popover, PopoverContent, PopoverTrigger } from './Popover'

export interface InfoTooltipProps extends Omit<PopoverTriggerProps, 'content'> {
	open?: boolean
	defaultOpen?: boolean
	onOpenChange?: (open: boolean) => void
	content?: React.ReactNode
	contentProps?: React.ComponentProps<typeof PopoverContent>
}

export const InfoPopover = ({
	children,
	open: openProp,
	defaultOpen,
	content,
	contentProps,
	asChild = false,
	onOpenChange,
	...props
}: InfoTooltipProps) => {
	const [open = false, setOpen] = useControllableState({
		value: openProp,
		defaultValue: defaultOpen,
		onChange: onOpenChange
	})

	return (
		<Popover
			open={open}
			onOpenChange={setOpen}
		>
			<PopoverTrigger
				asChild={asChild}
				{...props}
			>
				{children}
			</PopoverTrigger>

			<PopoverContent
				{...contentProps}
				className={cn('w-fit', contentProps?.className)}
			>
				{content}
			</PopoverContent>
		</Popover>
	)
}
